import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';

/**
 * Attaches the Okta access token as a Bearer header to backend API calls.
 * Only relative `/api` requests are decorated so the token is never leaked to
 * the absolute S3 presigned-URL PUT.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const oktaAuth = inject(OKTA_AUTH);
  const token = oktaAuth.getAccessToken();

  if (token && req.url.startsWith('/api')) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  return next(req);
};
